import { HttpClient } from '@angular/common/http';
import { ApiClientConfig } from './api-client.config';
import { AuthApi } from './auth/api.auth';
import { CommentsApi } from './comments/api.comments';
import { PageApi } from './fanpage/api.fanpage';
import { FriendApi } from './friend/api.friend';
import { LivestreamApi } from './livestream/api.livestream';
import { MediaApi } from './media/api.media';
import { PollApi } from './poll/api.poll';
import { PostApi } from './post/api.post';
import { ReactionsApi } from './reactions/api.reactions';
import { ReportApi } from './report/api.report';
import { StatisticsApi } from './statistics/api.statistics';
import { StorageApi } from './storage/api.storage';
import { UserProfileApi } from './user-profile/api.user-profile';
import { UserApi } from './user/api.user';
import { VerificationRequestsApi } from './verification-requests/api.verification-request';
export class ApiClient {
  readonly auth: AuthApi;

  readonly post: PostApi;
  readonly reactions: ReactionsApi;
  readonly comments: CommentsApi;
  readonly user: UserApi;
  readonly media: MediaApi;
  readonly storage: StorageApi;
  readonly userProfile: UserProfileApi;
  readonly statistics: StatisticsApi;
  readonly report: ReportApi;
  readonly verificationRequest: VerificationRequestsApi;
  readonly friend: FriendApi;
  readonly page: PageApi;
  readonly livestream: LivestreamApi;
  readonly poll: PollApi;
  constructor(
    private http: HttpClient,
    config: ApiClientConfig
  ) {
    this.auth = new AuthApi(this.http, config);
    this.post = new PostApi(this.http, config);
    this.reactions = new ReactionsApi(this.http, config);
    this.comments = new CommentsApi(this.http, config);
    this.user = new UserApi(this.http, config);
    this.media = new MediaApi(this.http, config);
    this.userProfile = new UserProfileApi(this.http, config);
    this.statistics = new StatisticsApi(this.http, config);
    this.storage = new StorageApi(this.http, config);
    this.report = new ReportApi(this.http, config);
    this.verificationRequest = new VerificationRequestsApi(this.http, config);
    this.friend = new FriendApi(this.http, config);
    this.page = new PageApi(this.http, config);
    this.livestream = new LivestreamApi(this.http, config);
    this.poll = new PollApi(this.http, config);
  }
}
